export const EvaluationPerformanceCriterion = {
    path: '/evaluation_performance_criterion',
    name: 'evaluation_performance_criterion',
    component: () => import('@/views/Evaluation/Measure/EvaluationPerformanceMeasurePage.vue'),
    props: {
        type: 'EVALUATION_PERFORMANCE',
    },
    children: [
        {
            path: '/evaluation_performance_criterion/add',
            name: 'evaluation_performance_criterion.add',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_criterion/edit/:id',
            name: 'evaluation_performance_criterion.edit',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_criterion/delete/:id',
            name: 'evaluation_performance_criterion.delete',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_criterion/view/:id',
            name: 'evaluation_performance_criterion.view',
            component: () => import('@/views/Evaluation/Measure/Form/EvaluationMeasureForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
    ]
}